export default __webpack_public_path__ + "static/media/smallgoods_cat.1ef4fce9.jpg";